<!-- =========================================================
     Start Short Course Details
========================================================= -->

<main class="ecb-x-details-page">

  <!-- Start cd-shell div -->
  <div class="cd-shell">
    <ng-container *ngIf="!isVOC">

      <!-- =====================================================
       Loading
  ====================================================== -->

      <section class="ecb-x-details-loading" *ngIf="isLoading">

        <div class="spinner-border text-primary" role="status">
        </div>

        <span class="text-muted">
          Loading course details...
        </span>

      </section>



      <!-- =====================================================
       Not Found
  ====================================================== -->

      <section class="ecb-x-details-not-found" *ngIf="
      !isLoading &&
      courseNotFound
    ">

        <div class="container-fluid px-3 px-md-4">

          <div class="ecb-x-details-not-found-card text-center">

            <div class="ecb-x-details-not-found-icon
                 mx-auto mb-3">

              <i class="bi bi-journal-x fs-2"></i>

            </div>

            <h2 class="fs-4 fw-bold mb-2">
              Course Not Found
            </h2>

            <p class="text-muted mb-4">
              The requested course could not be found.
            </p>

            <button type="button" class="btn btn-primary px-4" (click)="goBack()">

              <i class="bi bi-arrow-left me-2"></i>

              Back to Courses

            </button>

          </div>

        </div>

      </section>



      <!-- =====================================================
       Course Content
  ====================================================== -->

      <ng-container *ngIf="
      !isLoading &&
      course &&
      !courseNotFound
    ">


        <!-- ===================================================
         HERO
    ==================================================== -->

        <section class="ecb-x-details-hero">

          <div class="container-fluid px-3 px-md-4">


            <!-- Breadcrumb -->

            <!-- Course Navigation -->
            <div class="ecb-course-navigation">

              <!-- Back Button -->
              <button type="button" class="ecb-back-course-btn" (click)="goBack()">

                <i class="bi bi-arrow-left"></i>

                <span>
                  Back to Courses
                </span>

              </button>


              <!-- Breadcrumb -->
              <nav class="ecb-course-breadcrumb" aria-label="breadcrumb">

                <ol class="breadcrumb mb-0">

                  <!-- Home -->
                  <li class="breadcrumb-item">

                    <a routerLink="/" class="text-decoration-none">

                      Home

                    </a>

                  </li>


                  <!-- Short Courses -->
                  <li class="breadcrumb-item">

                    <a href="javascript:void(0)" class="text-decoration-none" (click)="goBack()">

                      Short Courses

                    </a>

                  </li>


                  <!-- Current Course -->
                  <li class="breadcrumb-item active" aria-current="page">

                    {{ courseTitle }}

                  </li>

                </ol>

              </nav>

            </div>

            <div class="row g-0 ecb-x-details-hero-card">

              <!-- Left -->
              <div class="col-lg-5">

                <div class="ecb-x-details-hero-content">

                  <span class="ecb-x-details-course-code mb-3">
                    {{ courseCode }}
                  </span>

                  <h1 class="display-5 fw-bold
                 ecb-x-details-main-title mb-2">
                    {{ courseTitle }}
                  </h1>

                  <h2 class="fs-5 fw-bold
                 ecb-x-details-hero-subtitle mb-3">
                    Build the skills and confidence
                    you need.
                  </h2>

                  <div class="cd-hero-description course-rte-view" *ngIf="course.nShortDescription"
                    [innerHTML]="course.nShortDescription | safeHtml">
                  </div>

                  <div class="d-flex flex-wrap
                  align-items-center gap-3">

                    <button *ngIf="!hasPrice || (hasPrice  && !isCourseAvailableInCalendar ) " type="button" class="btn ecb-x-details-green-button
                 px-4 py-3 fw-bold" (click)="enquireNow()">

                      Enquire Now

                      <i class="bi bi-arrow-right ms-2"></i>

                    </button>

                    <a *ngIf="hasBrochure" [href]="brochureUrl" target="_blank" rel="noopener noreferrer" class="btn btn-outline-primary
                 px-4 py-3 fw-semibold">

                      <!-- Start fa i -->
                      <i class="fa fa-download" aria-hidden="true">
                      </i>
                      <!-- End fa i -->
                      Download Brochure

                    </a>

                  </div>

                </div>

              </div>


              <!-- Right -->
              <div class="col-lg-7">
                <div class="ecb-x-details-hero-image-wrapper" [class.ecb-hero-image-sized]="isHeroImageSized"
                  [style.justify-content]="isHeroImageSized ? heroImageJustifyContent : null">


                  <img *ngIf="hasCourseImage" [src]="imageUrl" [alt]="courseTitle" class="ecb-x-details-hero-image"
                    [ngStyle]="heroImageStyles" (error)="onImageError()">

                  <div class="ecb-x-details-hero-fallback" *ngIf="!hasCourseImage">

                    <div class="text-center">

                      <div class="ecb-x-details-fallback-icon
                      mx-auto mb-3">

                        <i class="bi bi-mortarboard fs-1"></i>

                      </div>

                      <h3 class="fs-4 fw-bold mb-1">
                        ECB Training
                      </h3>

                      <p class="text-muted mb-0">
                        Professional Training Courses
                      </p>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>



        <!-- ===================================================
         MAIN CONTENT
    ==================================================== -->

        <section class="ecb-x-details-content-section">

          <div class="container-fluid px-3 px-md-4">


            <!-- =================================================
             About + Fees
        ================================================== -->

            <div class="row g-4 mb-4">


              <!-- About -->

              <div class="col-lg-8">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-file-earmark-text fs-5"></i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">
                        About This Course
                      </h2>

                      <div class="ecb-x-details-heading-line"></div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content
                       text-secondary lh-lg" [innerHTML]="courseDescription | safeHtml">
                  </div>


                  <a *ngIf="hasBrochure" [href]="brochureUrl" target="_blank" rel="noopener noreferrer" class="btn ecb-x-details-green-button
                       mt-3 px-4 py-3 fw-bold">

                    <!-- Start fa i -->
                    <i class="fa fa-download" aria-hidden="true">
                    </i>
                    <!-- End fa i -->
                    Download Brochure

                  </a>

                </article>

              </div>



              <!-- Fees & Location -->

              <div class="col-lg-4">

                <article class="ecb-x-details-info-card
                     ecb-x-details-fee-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-geo-alt fs-5"></i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">
                        Fees & Location
                      </h2>

                      <div class="ecb-x-details-heading-line"></div>

                    </div>

                  </div>



                  <!-- Fees -->

                  <div class="d-flex align-items-start
                       gap-3 py-3">

                    <div class="ecb-x-details-secondary-icon">

                      <i class="bi bi-currency-dollar fs-3"></i>

                    </div>


                    <div>

                      <div class="fw-bold mb-1">
                        Course Fees
                      </div>

                      <div class="fw-semibold
                           ecb-x-details-dark-text">

                        <h2>{{ coursePrice }}</h2>

                      </div>

                    </div>

                  </div>


                  <hr class="my-2">



                  <!-- Locations -->

                  <div class="d-flex align-items-start
                       gap-3 py-3">

                    <div class="ecb-x-details-secondary-icon">

                      <i class="bi bi-geo-alt-fill fs-4"></i>

                    </div>


                    <div class="flex-grow-1">

                      <div class="fw-bold mb-2">
                        Locations
                      </div>


                      <!-- Available Locations -->

                      <ng-container *ngIf="courseLocations.length > 0">

                        <div class="text-secondary mb-1" *ngFor="let location of courseLocations">



                          {{ location }}

                        </div>

                      </ng-container>


                      <!-- No Locations -->

                      <div *ngIf="courseLocations.length === 0">

                        <div class="small text-muted mb-1">
                          Contact ECB Training for upcoming course locations.
                        </div>

                        <a href="tel:1300322486" class="fw-semibold text-decoration-none ecb-x-details-contact-number">

                          <i class="bi bi-telephone-fill me-1"></i>

                          1300 322 486

                        </a>

                      </div>

                    </div>

                  </div>



                  <!-- Buttons -->

                  <div class="row g-2 mt-2">

                  <!--  <div *ngIf="isCourseAvailableInCalendar && courseOccurrences.length ==0" [class.col-sm-6]="!hasPrice" [class.col-12]="hasPrice">

                      <button type="button" class="btn ecb-x-details-book-button
                           w-100 py-3 fw-bold" (click)="bookCourse()">

                        Book Now

                        <i class="bi bi-arrow-right ms-2"></i>

                      </button>

                    </div>  

 -->
                    <div class="col-12" *ngIf="courseOccurrences.length || hasPrice">
                      <button type="button" class="btn ecb-x-details-book-button w-100 py-3 fw-bold"
                          (click)="showingOccurrencePicker = true"><i class="bi bi-cart-plus me-2"></i> Add to Cart · Choose Date</button>
                    </div>
                    <div 
           [class.col-12]="true">

                      <button type="button" class="btn btn-outline-primary  
                           w-100 py-3 fw-bold" (click)="enquireMain()">

                        Enquire Now

                      </button>

                    </div>
 
                    <!-- <div *ngIf="!hasPrice  !!  !isCourseAvailableInCalendar  "
                      [class.col-sm-6]="isCourseAvailableInCalendar && hasPrice" [class.col-12]="!isCourseAvailableInCalendar && !hasPrice">

                      <button type="button" class="btn btn-outline-primary  
                           w-100 py-3 fw-bold" (click)="enquireMain()">

                        Enquire Now

                      </button>

                    </div> -->

                  </div>


                  <!-- Contact -->

                  <div class="ecb-x-details-contact-box d-flex align-items-center gap-3 mt-3">

                    <div class="ecb-x-details-phone-icon">

                      <i class="bi bi-telephone-fill fs-5"></i>

                    </div>

                    <div>

                      <div class="small fw-semibold text-secondary mb-1">
                        Contact ECB Training for fees and upcoming course locations.
                      </div>

                      <a href="tel:1300322486" class="fw-bold text-decoration-none ecb-x-details-contact-number">

                        1300 322 486

                      </a>

                    </div>

                  </div>



                </article>

              </div>

            </div>



            <!-- =================================================
             Course For + Covered
        ================================================== -->

            <div class="row g-4 mb-4">


              <!-- Course For -->

              <div class="col-lg-6" *ngIf="hasContent(courseFor)">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-people fs-5"></i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">
                        Who is this course for?
                      </h2>

                      <div class="ecb-x-details-heading-line"></div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content ecb-x-details-check-content
                       text-secondary lh-lg" [innerHTML]="courseFor | safeHtml">
                  </div>

                </article>

              </div>



              <!-- Covered -->

              <div class="col-lg-6" *ngIf="hasContent(covered)">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-check-lg fs-5"></i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">
                        What is covered in this course?
                      </h2>

                      <div class="ecb-x-details-heading-line"></div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content
                       ecb-x-details-check-content
                       text-secondary lh-lg" [innerHTML]="covered | safeHtml">
                  </div>

                </article>

              </div>

            </div>



            <!-- =================================================
             Preconditions
        ================================================== -->

            <div class="mb-4" *ngIf="hasContent(preconditions)">

              <article class="ecb-x-details-info-card">

                <div class="ecb-x-details-card-heading">

                  <div class="ecb-x-details-heading-icon">

                    <i class="bi bi-file-earmark-check fs-5"></i>

                  </div>

                  <div>

                    <h2 class="fs-4 fw-bold mb-1">
                      Are there any preconditions for attending this course?
                    </h2>

                    <div class="ecb-x-details-heading-line"></div>

                  </div>

                </div>


                <div class="ecb-x-details-rte-content ecb-x-details-check-content
                     text-secondary lh-lg" [innerHTML]="preconditions | safeHtml">
                </div>

              </article>

            </div>



            <!-- =================================================
             Duration + Assessments
        ================================================== -->

            <div class="row g-4 mb-4">


              <!-- Duration -->

              <div class="col-lg-12" *ngIf="hasContent(howLongCourse)">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-clock fs-5"></i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">
                        How long is the course?
                      </h2>

                      <div class="ecb-x-details-heading-line"></div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content ecb-x-details-check-content
                       text-secondary lh-lg" [innerHTML]="howLongCourse | safeHtml">
                  </div>

                </article>

              </div>



              <!-- Assessment -->

              <div class="col-lg-12" *ngIf="
              hasContent(knowledgeAssessment) ||
              hasContent(skillsAssessment)
            ">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-clipboard-check fs-5"></i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">
                        How will I be assessed?
                      </h2>

                      <div class="ecb-x-details-heading-line"></div>

                    </div>

                  </div>


                  <div class="row">
                    <!-- Knowledge -->
                    <div class="col-lg-6">
                      <div class="ecb-x-details-assessment-box mb-3" *ngIf="
                  hasContent(knowledgeAssessment)
                ">

                        <div class="d-flex
                         align-items-start gap-3">

                          <div class="ecb-x-details-secondary-icon">

                            <i class="bi bi-book fs-4"></i>

                          </div>


                          <div class="flex-grow-1">

                            <h3 class="fs-6 fw-bold mb-2">
                              Knowledge Assessment
                            </h3>

                            <div class="ecb-x-details-rte-content ecb-x-details-check-content
                             text-secondary" [innerHTML]="knowledgeAssessment | safeHtml">
                            </div>

                          </div>

                        </div>

                      </div>
                    </div>
                    <div class="col-lg-6">

                      <!-- Skills -->

                      <div class="ecb-x-details-assessment-box" *ngIf="
                  hasContent(skillsAssessment)
                ">

                        <div class="d-flex
                         align-items-start gap-3">

                          <div class="ecb-x-details-secondary-icon">

                            <i class="bi bi-gear fs-4"></i>

                          </div>


                          <div class="flex-grow-1">

                            <h3 class="fs-6 fw-bold mb-2">
                              Practical Skills Assessment
                            </h3>

                            <div class="ecb-x-details-rte-content ecb-x-details-check-content
                             text-secondary" [innerHTML]="skillsAssessment | safeHtml">
                            </div>

                          </div>

                        </div>

                      </div>
                    </div>

                  </div>

                </article>

              </div>

            </div>



            <!-- =================================================
             Certificate
        ================================================== -->

            <div class="mb-4" *ngIf="hasContent(certificateValid)">

              <article class="ecb-x-details-info-card">

                <div class="ecb-x-details-card-heading">

                  <div class="ecb-x-details-heading-icon">

                    <i class="bi bi-award fs-5"></i>

                  </div>

                  <div>

                    <h2 class="fs-4 fw-bold mb-1">
                      How long is my certificate valid? 
                    </h2>

                    <div class="ecb-x-details-heading-line"></div>

                  </div>

                </div>


                <div class="ecb-x-details-rte-content ecb-x-details-check-content
                     text-secondary lh-lg" [innerHTML]="certificateValid | safeHtml">
                </div>

              </article>




            </div>

            <!-- =================================================
     Course Units
================================================== -->

            <!-- <div class="mb-4" *ngIf="courseUnits.length > 0">

              <article class="ecb-x-details-info-card"> -->

                <!-- Heading -->

              <!--   <div class="ecb-x-details-card-heading">

                  <div class="ecb-x-details-heading-icon">

                    <i class="bi bi-book fs-5"></i>

                  </div>

                  <div>

                    <h2 class="fs-4 fw-bold mb-1">
                      Course Units
                    </h2>

                    <div class="ecb-x-details-heading-line"></div>

                  </div>

                </div> -->


                <!-- Intro -->

               <!--  <p class="text-secondary mb-3">

                  This course includes the following units of competency:

                </p> -->


                <!-- Unit List -->
             <!--    <div class="ecb-x-details-unit-list">

                  <div class="ecb-x-details-unit-row" *ngFor="
      let unit of courseUnits;
      let i = index
    "> -->

                    <!-- Unit Code -->
<!-- 
                    <div class="ecb-x-details-unit-code fw-bold">

                      {{
                      unit.code ||
                      unit.nationalCode ||
                      'Unit ' + (i + 1)
                      }}

                    </div> -->


                    <!-- Unit Name -->

                   <!--  <div class="ecb-x-details-unit-name text-secondary">

                      {{ unit.name }}

                    </div>

                  </div>

                </div>

              </article>

            </div> -->


            <div class="mb-4" *ngIf="courseOccurrences.length > 0">

              <article class="ecb-x-details-info-card">

                <!-- Heading -->
                <div class="ecb-x-details-card-heading">

                  <div class="ecb-x-details-heading-icon">
                    <i class="bi bi-calendar3 fs-5"></i>
                  </div>

                  <div>

                    <h2 class="fs-4 fw-bold mb-1">
                      Upcoming Course Dates
                    </h2>

                    <div class="ecb-x-details-heading-line"></div>

                  </div>

                </div>


                <!-- Intro -->
                <p class="text-secondary mb-3">
                  Select from the upcoming available course dates below.
                </p>


                <!-- Occurrence Boxes -->
                <div class="ecb-x-occurrence-grid">

                  <div class="ecb-x-occurrence-box" *ngFor="let occurrence of courseOccurrences">

                    <div class="ecb-x-occurrence-date-icon">

                      <i class="bi bi-calendar-event"></i>

                    </div>


                    <div class="ecb-x-occurrence-content">

                      <span class="ecb-x-occurrence-label">
                        Course Date
                      </span>

                      <div class="ecb-x-occurrence-date-row">

                        <div class="ecb-x-occurrence-date">
                          {{ occurrence.startDate | date:'dd MMMM yyyy' }}
                        </div>

                        <button type="button" class="ecb-x-occurrence-enquiry-button"
                          (click)="openOccurrences(occurrence)">

                          Enquire Now

                        </button>

                      </div>


                      <div class="ecb-x-occurrence-end" *ngIf="
      occurrence.endDate &&
      occurrence.endDate !== occurrence.startDate
    ">

                        <span>to</span>

                        {{ occurrence.endDate | date:'dd MMMM yyyy' }}

                      </div>

                    </div>

                  </div>

                </div>

              </article>

            </div>



          </div>

        </section>


        <div class="container-fluid px-3 px-md-4 pb-4">
          <section class="cd-training-recognition" aria-label="Training recognition and funding information">
           <!--  <div class="cd-training-recognition-logo">
              <img src="assets/images/vicseg-nationally-recognised-training.png" alt="Nationally Recognised Training">
            </div> -->

            <div class="cd-training-recognition-copy">
        <!--       <p>VICSEG New Futures trading as New Futures Training TOID: 21203.</p>
              <p>This training is delivered with Victorian and Commonwealth Government funding. Eligibility criteria
                apply.
              </p>
              <p>We encourage individuals with disabilities to access our training.</p> -->
          <p>ECB Training Services.</p>
              <p>Registered Training Organisation (RTO) 41369.</p>
              <p>Victoria | Northern Territory</p>
            </div>
          </section>
        </div>
      </ng-container>
    </ng-container>


    <ng-container *ngIf="isVOC">

      <!-- =====================================================
       Loading
  ====================================================== -->

      <div class="container-fluid px-3 px-md-4 py-5 text-center" *ngIf="isLoading">

        <div class="spinner-border text-primary">
        </div>

        <div class="text-muted mt-3">
          Loading VOC details...
        </div>

      </div>


      <!-- =====================================================
       VOC Details
  ====================================================== -->

      <main class="ecb-x-voc-details-page" *ngIf="
      !isLoading &&
      !courseNotFound &&
      vocDetails
    ">


        <!-- ===================================================
         Hero
    ==================================================== -->

        <section class="ecb-x-voc-hero">

          <div class="container-fluid px-3 px-md-4">




            <div class="ecb-course-navigation">

              <!-- Back Button -->
              <button type="button" class="ecb-back-course-btn" (click)="goBack()">

                <i class="bi bi-arrow-left"></i>

                <span>
                  Back to Courses
                </span>

              </button>


              <!-- Breadcrumb -->
              <nav class="ecb-course-breadcrumb" aria-label="breadcrumb">

                <ol class="breadcrumb mb-0">

                  <!-- Home -->
                  <li class="breadcrumb-item">

                    <a routerLink="/" class="text-decoration-none">

                      Home

                    </a>

                  </li>


                  <!-- Short Courses -->
                  <li class="breadcrumb-item">

                    <a href="javascript:void(0)" class="text-decoration-none" (click)="goBack()">

                      Short Courses

                    </a>

                  </li>


                  <!-- Current Course -->
                  <li class="breadcrumb-item active" aria-current="page">

                    {{ vocName }}

                  </li>

                </ol>

              </nav>

            </div>


            <div class="row align-items-center g-4">

              <!-- Left -->

              <div class="col-12 col-lg-6">

                <span class="ecb-x-voc-code-badge
                     fw-bold d-inline-block mb-3">

                  {{ vocCode }}

                </span>


                <h1 class="display-5 fw-bold
                     ecb-x-voc-main-title mb-2">

                  {{ vocName }}

                </h1>


                <h2 class="fs-4 fw-bold
                     ecb-x-voc-subtitle mb-3">

                  Verification of Competency (VOC)

                </h2>


                <p class="fs-5 fw-semibold
                     ecb-x-voc-tagline mb-3">

                  Demonstrate your skills.
                  Work with confidence.

                </p>


                <div class="ecb-x-voc-hero-description
                     text-secondary mb-4">
                  <p>Our Excavator VoC assesses your practical ability to safely operate an excavator in the workplace,
                    in
                    line with industry standards and site requirements.

                    Verification of Competency (VoC) provides employers and workers with confidence that operators have
                    the current knowledge and practical skills required to safely operate equipment in the workplace.

                    The assessment is suitable for experienced operators who already hold the relevant licence, ticket,
                    Statement of Attainment or qualification.</p>
                </div>


                <button type="button" class="btn ecb-x-details-green-button
                     px-4 py-3 fw-bold" (click)="enquireNow()">

                  Enquire Now

                  <i class="bi bi-arrow-right
                       ms-2">
                  </i>

                </button>

              </div>


              <!-- Right -->

              <div class="col-12 col-lg-6">

                <div class="ecb-x-voc-hero-image">

                  <img src="assets/images/categories/default-category.jpg" alt="Verification of Competency"
                    class="img-fluid">

                </div>

              </div>

            </div>

          </div>

        </section>


        <!-- ===================================================
         Details
    ==================================================== -->

        <section class="ecb-x-voc-content-section">

          <div class="container-fluid px-3 px-md-4">


            <!-- =================================================
             About + Course Details
        ================================================== -->

            <div class="row g-3 mb-3">


              <!-- About -->

              <div class="col-12 col-lg-8">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-file-earmark-text fs-5">
                      </i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">

                        About This VOC

                      </h2>

                      <div class="ecb-x-details-heading-line">
                      </div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content" [innerHTML]="vocDescription | safeHtml">
                  </div>

                </article>

              </div>


              <!-- Course Details -->

              <div class="col-12 col-lg-4">

                <article class="ecb-x-details-info-card
                    h-100 d-flex
                     flex-column">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-geo-alt-fill fs-3">
                      </i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">

                        Course Details

                      </h2>

                      <div class="ecb-x-details-heading-line">
                      </div>

                    </div>

                  </div>


                  <!-- Delivery -->

                  <!--   <div class="d-flex align-items-start
                       gap-3 mb-4" *ngIf="vocDelivery">

                    <div class="ecb-x-voc-detail-icon">

                      <i class="bi bi-mortarboard-fill"></i>

                    </div>

                    <div>

                      <div class="fw-bold mb-1">
                        Delivery
                      </div>

                      <div class="text-secondary">
                        {{ vocDeliveryText }}
                      </div>

                    </div>

                  </div> -->




                  <!-- Cost -->

                  <div class="d-flex align-items-start
                       gap-3 mb-4" *ngIf="
                  vocCost !== null &&
                  vocCost !== undefined
                ">

                    <div class="ecb-x-voc-detail-icon">

                      <i class="bi bi-currency-dollar fs-3"></i>

                    </div>

                    <div>

                      <div class="fw-bold mb-1">
                        Cost
                      </div>


                      <h2> AUD
                        {{
                        vocCost |
                        number:'1.2-2'
                        }}</h2>




                    </div>

                  </div>

                  <hr>
                  <!-- Location -->

                  <div class="d-flex align-items-start
                       gap-3 mb-4" *ngIf="vocLocation">

                    <div class="ecb-x-voc-detail-icon">

                      <i class="bi bi-geo-alt-fill fs-3 "></i>

                    </div>

                    <div>

                      <div class="fw-bold mb-1">
                        Location
                      </div>

                      <!--   <div class="text-secondary">
                       {{ vocLocationText || '-' }}
                      </div>
 -->

                      <div class="text-secondary ecb-x-details-rte-content lh-lg"
                        [innerHTML]="vocLocation || '-' | safeHtml">
                      </div>
                    </div>

                  </div>


                  <div class="mt-auto pt-3">

                    <button type="button" class="btn btn-outline-primary w-100 py-3 fw-bold" (click)="enquireNow()">

                      Enquire Now

                      <i class="bi bi-arrow-right
                           ms-2">
                      </i>

                    </button>

                  </div>

                </article>

              </div>

            </div>


            <!-- =================================================
             Requirements + Delivery
        ================================================== -->

            <div class="row g-3 mb-3">


              <!-- Entry Requirements -->

              <div class="col-12 col-lg-6" *ngIf="vocRequirements">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-people-fill fs-5">
                      </i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">

                        Entry Requirements

                      </h2>

                      <div class="ecb-x-details-heading-line">
                      </div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content" [innerHTML]="vocRequirements | safeHtml">
                  </div>

                </article>

              </div>


              <!-- VOC Delivery -->

              <div class="col-12 col-lg-6" *ngIf="vocDelivery">

                <article class="ecb-x-details-info-card h-100">

                  <div class="ecb-x-details-card-heading">

                    <div class="ecb-x-details-heading-icon">

                      <i class="bi bi-check-lg fs-5">
                      </i>

                    </div>

                    <div>

                      <h2 class="fs-4 fw-bold mb-1">

                        VOC Delivery

                      </h2>

                      <div class="ecb-x-details-heading-line">
                      </div>

                    </div>

                  </div>


                  <div class="ecb-x-details-rte-content" [innerHTML]="vocDelivery | safeHtml">
                  </div>

                </article>

              </div>

            </div>


            <!-- =================================================
             Certification
        ================================================== -->

            <div class="mb-4" *ngIf="vocCertification">

              <article class="ecb-x-details-info-card">

                <div class="ecb-x-details-card-heading">

                  <div class="ecb-x-details-heading-icon">

                    <i class="bi bi-award-fill fs-5">
                    </i>

                  </div>

                  <div>

                    <h2 class="fs-4 fw-bold mb-1">

                      VOC Certification

                    </h2>

                    <div class="ecb-x-details-heading-line">
                    </div>

                  </div>

                </div>


                <div class="ecb-x-details-rte-content" [innerHTML]="vocCertification | safeHtml">
                </div>

              </article>

            </div>


          </div>

        </section>
        <div class="container-fluid px-3 px-md-4 pb-4">
          <section class="cd-training-recognition" aria-label="Training recognition and funding information">
          <!--   <div class="cd-training-recognition-logo">
              <img src="assets/images/vicseg-nationally-recognised-training.png" alt="Nationally Recognised Training">
            </div> -->

            <div class="cd-training-recognition-copy">
           <!--    <p>VICSEG New Futures trading as New Futures Training TOID: 21203.</p>
              <p>This training is delivered with Victorian and Commonwealth Government funding. Eligibility criteria
                apply.
              </p>
              <p>We encourage individuals with disabilities to access our training.</p> -->
              <p>ECB Training Services.</p>
              <p>Registered Training Organisation (RTO) 41369.</p>
              <p>Victoria | Northern Territory</p>
            </div>
          </section>
        </div>

      </main>

    </ng-container>
  </div>
</main>

<!-- =========================================================
     End Short Course Details
========================================================= -->
<app-occurrence-picker *ngIf="showingOccurrencePicker && !isVOC && course" kind="SHORT" [courseId]="courseId" (closed)="showingOccurrencePicker=false"></app-occurrence-picker>
